
  <div class="doc-insidecard">

  <div *ngIf="isLoading" class="loader">
    <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
  </div>

  <ng-container *ngIf="navigateToStepperForm && !isLoading">
    <wm-app class="view"></wm-app>
  </ng-container>

</div>
